import { React, useState, useRef, useEffect } from "react";
const CricketScoreBoard = ({ eventDetails, scoreboardData }) => {
  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: "rgb(255, 255, 255)",
        padding: "2px 4px",
        display: "flex",
        flexDirection: "column",
        gap: "1px",
        minHeight: "fit-content",
        margin: "-8px 0px 0px"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <input
            type="checkbox"
            style={{
              width: "14px",
              height: "14px",
              cursor: "pointer",
              margin: "0px"
            }}
          />{" "}
          <span>
            <i class="fas fa-volume-mute"></i>
          </span>
        </div>{" "}
        <div
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "rgb(68, 68, 68)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: "1 1 0%"
          }}
        >
          {scoreboardData?.commentry}
        </div>
      </div>{" "}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
          borderTop: "1px solid rgb(240, 240, 240)",
          paddingTop: "4px"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: "rgb(26, 35, 126)"
            }}
          >
            {scoreboardData?.team1Name}
          </span>{" "}
          <span
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: "rgb(34, 34, 34)"
            }}
          >
            {scoreboardData?.team1Score}-{scoreboardData?.team1Wicket}
          </span>{" "}
          <span
            style={{
              fontSize: "13px",
              color: "rgb(102, 102, 102)",
              fontWeight: "500"
            }}
          >
            ({scoreboardData?.team1Over} Over)
          </span>
        </div>{" "}
        <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
          <div
            style={{
              background: "rgb(241, 243, 244)",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "700"
            }}
          >
            CRR:{" "}
            <span style={{ color: "rgb(46, 125, 50)" }}>
              {scoreboardData?.team1RunRate}
            </span>
          </div>
        </div>
      </div>{" "}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          fontSize: "12px",
          color: "rgb(85, 85, 85)",
          paddingTop: "2px"
        }}
      >
        <div style={{ display: "flex", gap: "4px" }}>
          <span style={{ fontWeight: "700", color: "rgb(153, 153, 153)" }}>
            This Over:
          </span>{" "}
          <span
            style={{
              letterSpacing: "1px",
              fontFamily: "monospace",
              fontWeight: "bold",
              fontSize: "12px"
            }}
          >
            {scoreboardData?.lastSixBalls}
          </span>
        </div>{" "}
      </div>
    </div>
  );
};

export default CricketScoreBoard;
